import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'ai-assistants-api.vendasta-local.com',
  'test': '',
  'demo': 'ai-assistants-demo.apigateway.co',
  'prod': 'ai-assistants-prod.apigateway.co',
  'production': 'ai-assistants-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FunctionParameterParameterLocation = /*#__PURE__*/function (FunctionParameterParameterLocation) {
  FunctionParameterParameterLocation[FunctionParameterParameterLocation["LOCATION_BODY"] = 0] = "LOCATION_BODY";
  FunctionParameterParameterLocation[FunctionParameterParameterLocation["LOCATION_QUERY_PARAM"] = 1] = "LOCATION_QUERY_PARAM";
  return FunctionParameterParameterLocation;
}(FunctionParameterParameterLocation || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var GoalChannel = /*#__PURE__*/function (GoalChannel) {
  GoalChannel[GoalChannel["GOAL_CHANNEL_INVALID"] = 0] = "GOAL_CHANNEL_INVALID";
  GoalChannel[GoalChannel["GOAL_CHANNEL_SMS"] = 1] = "GOAL_CHANNEL_SMS";
  GoalChannel[GoalChannel["GOAL_CHANNEL_EMAIL"] = 2] = "GOAL_CHANNEL_EMAIL";
  GoalChannel[GoalChannel["GOAL_CHANNEL_PLATFORM"] = 3] = "GOAL_CHANNEL_PLATFORM";
  GoalChannel[GoalChannel["GOAL_CHANNEL_WEBCHAT"] = 4] = "GOAL_CHANNEL_WEBCHAT";
  GoalChannel[GoalChannel["GOAL_CHANNEL_VOICE"] = 5] = "GOAL_CHANNEL_VOICE";
  GoalChannel[GoalChannel["GOAL_CHANNEL_WHATSAPP"] = 6] = "GOAL_CHANNEL_WHATSAPP";
  GoalChannel[GoalChannel["GOAL_CHANNEL_INSTAGRAM"] = 7] = "GOAL_CHANNEL_INSTAGRAM";
  GoalChannel[GoalChannel["GOAL_CHANNEL_FACEBOOK"] = 8] = "GOAL_CHANNEL_FACEBOOK";
  GoalChannel[GoalChannel["GOAL_CHANNEL_AUTOMATION"] = 9] = "GOAL_CHANNEL_AUTOMATION";
  return GoalChannel;
}(GoalChannel || {});
var GoalType = /*#__PURE__*/function (GoalType) {
  GoalType[GoalType["GOAL_TYPE_INVALID"] = 0] = "GOAL_TYPE_INVALID";
  GoalType[GoalType["GOAL_TYPE_GOAL"] = 1] = "GOAL_TYPE_GOAL";
  GoalType[GoalType["GOAL_TYPE_KNOWLEDGE"] = 2] = "GOAL_TYPE_KNOWLEDGE";
  GoalType[GoalType["GOAL_TYPE_PERSONALITY"] = 3] = "GOAL_TYPE_PERSONALITY";
  GoalType[GoalType["GOAL_TYPE_CUSTOM"] = 4] = "GOAL_TYPE_CUSTOM";
  return GoalType;
}(GoalType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AssistantType = /*#__PURE__*/function (AssistantType) {
  AssistantType[AssistantType["ASSISTANT_TYPE_UNSPECIFIED"] = 0] = "ASSISTANT_TYPE_UNSPECIFIED";
  AssistantType[AssistantType["ASSISTANT_TYPE_SYSTEM"] = 1] = "ASSISTANT_TYPE_SYSTEM";
  AssistantType[AssistantType["ASSISTANT_TYPE_INBOX"] = 2] = "ASSISTANT_TYPE_INBOX";
  AssistantType[AssistantType["ASSISTANT_TYPE_SOCIAL_MARKETING"] = 3] = "ASSISTANT_TYPE_SOCIAL_MARKETING";
  AssistantType[AssistantType["ASSISTANT_TYPE_VOICE_RECEPTIONIST"] = 4] = "ASSISTANT_TYPE_VOICE_RECEPTIONIST";
  AssistantType[AssistantType["ASSISTANT_TYPE_CUSTOM"] = 5] = "ASSISTANT_TYPE_CUSTOM";
  AssistantType[AssistantType["ASSISTANT_TYPE_SALES_COACH"] = 6] = "ASSISTANT_TYPE_SALES_COACH";
  AssistantType[AssistantType["ASSISTANT_TYPE_REPUTATION_MANAGEMENT_REVIEW_AGENT"] = 7] = "ASSISTANT_TYPE_REPUTATION_MANAGEMENT_REVIEW_AGENT";
  return AssistantType;
}(AssistantType || {});
var VendorModel = /*#__PURE__*/function (VendorModel) {
  VendorModel[VendorModel["VENDOR_MODEL_UNSPECIFIED"] = 0] = "VENDOR_MODEL_UNSPECIFIED";
  VendorModel[VendorModel["VENDOR_MODEL_OPEN_AI_REALTIME"] = 1] = "VENDOR_MODEL_OPEN_AI_REALTIME";
  VendorModel[VendorModel["VENDOR_MODEL_DEEPGRAM"] = 2] = "VENDOR_MODEL_DEEPGRAM";
  return VendorModel;
}(VendorModel || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ChatAnswerFunctionExecutionJobStatus = /*#__PURE__*/function (ChatAnswerFunctionExecutionJobStatus) {
  ChatAnswerFunctionExecutionJobStatus[ChatAnswerFunctionExecutionJobStatus["FUNCTION_EXECUTION_JOB_STATUS_INVALID"] = 0] = "FUNCTION_EXECUTION_JOB_STATUS_INVALID";
  ChatAnswerFunctionExecutionJobStatus[ChatAnswerFunctionExecutionJobStatus["FUNCTION_EXECUTION_JOB_STATUS_QUEUED"] = 1] = "FUNCTION_EXECUTION_JOB_STATUS_QUEUED";
  ChatAnswerFunctionExecutionJobStatus[ChatAnswerFunctionExecutionJobStatus["FUNCTION_EXECUTION_JOB_STATUS_RUNNING"] = 2] = "FUNCTION_EXECUTION_JOB_STATUS_RUNNING";
  ChatAnswerFunctionExecutionJobStatus[ChatAnswerFunctionExecutionJobStatus["FUNCTION_EXECUTION_JOB_STATUS_COMPLETE"] = 3] = "FUNCTION_EXECUTION_JOB_STATUS_COMPLETE";
  return ChatAnswerFunctionExecutionJobStatus;
}(ChatAnswerFunctionExecutionJobStatus || {});
var ChatChannel = /*#__PURE__*/function (ChatChannel) {
  ChatChannel[ChatChannel["CHAT_CHANNEL_INVALID"] = 0] = "CHAT_CHANNEL_INVALID";
  ChatChannel[ChatChannel["CHAT_CHANNEL_UNSPECIFIED"] = 1] = "CHAT_CHANNEL_UNSPECIFIED";
  ChatChannel[ChatChannel["CHAT_CHANNEL_WEB"] = 2] = "CHAT_CHANNEL_WEB";
  ChatChannel[ChatChannel["CHAT_CHANNEL_SMS"] = 3] = "CHAT_CHANNEL_SMS";
  ChatChannel[ChatChannel["CHAT_CHANNEL_WHATSAPP"] = 4] = "CHAT_CHANNEL_WHATSAPP";
  ChatChannel[ChatChannel["CHAT_CHANNEL_FACEBOOK"] = 5] = "CHAT_CHANNEL_FACEBOOK";
  ChatChannel[ChatChannel["CHAT_CHANNEL_INSTAGRAM"] = 7] = "CHAT_CHANNEL_INSTAGRAM";
  ChatChannel[ChatChannel["CHAT_CHANNEL_AUTOMATION"] = 8] = "CHAT_CHANNEL_AUTOMATION";
  ChatChannel[ChatChannel["CHAT_CHANNEL_PLATFORM"] = 9] = "CHAT_CHANNEL_PLATFORM";
  return ChatChannel;
}(ChatChannel || {});
var ChatMessageRole = /*#__PURE__*/function (ChatMessageRole) {
  ChatMessageRole[ChatMessageRole["CHAT_MESSAGE_ROLE_INVALID"] = 0] = "CHAT_MESSAGE_ROLE_INVALID";
  ChatMessageRole[ChatMessageRole["CHAT_MESSAGE_ROLE_USER"] = 1] = "CHAT_MESSAGE_ROLE_USER";
  ChatMessageRole[ChatMessageRole["CHAT_MESSAGE_ROLE_ASSISTANT"] = 2] = "CHAT_MESSAGE_ROLE_ASSISTANT";
  return ChatMessageRole;
}(ChatMessageRole || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class NamespaceAccountGroupNamespace {
  static fromProto(proto) {
    let m = new NamespaceAccountGroupNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class NamespaceGlobalNamespace {
  static fromProto(proto) {
    let m = new NamespaceGlobalNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class Namespace {
  static fromProto(proto) {
    let m = new Namespace();
    m = Object.assign(m, proto);
    if (proto.accountGroupNamespace) {
      m.accountGroupNamespace = NamespaceAccountGroupNamespace.fromProto(proto.accountGroupNamespace);
    }
    if (proto.partnerNamespace) {
      m.partnerNamespace = NamespacePartnerNamespace.fromProto(proto.partnerNamespace);
    }
    if (proto.systemNamespace) {
      m.systemNamespace = NamespaceSystemNamespace.fromProto(proto.systemNamespace);
    }
    if (proto.globalNamespace) {
      m.globalNamespace = NamespaceGlobalNamespace.fromProto(proto.globalNamespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupNamespace !== 'undefined' && this.accountGroupNamespace !== null) {
      toReturn['accountGroupNamespace'] = 'toApiJson' in this.accountGroupNamespace ? this.accountGroupNamespace.toApiJson() : this.accountGroupNamespace;
    }
    if (typeof this.partnerNamespace !== 'undefined' && this.partnerNamespace !== null) {
      toReturn['partnerNamespace'] = 'toApiJson' in this.partnerNamespace ? this.partnerNamespace.toApiJson() : this.partnerNamespace;
    }
    if (typeof this.systemNamespace !== 'undefined' && this.systemNamespace !== null) {
      toReturn['systemNamespace'] = 'toApiJson' in this.systemNamespace ? this.systemNamespace.toApiJson() : this.systemNamespace;
    }
    if (typeof this.globalNamespace !== 'undefined' && this.globalNamespace !== null) {
      toReturn['globalNamespace'] = 'toApiJson' in this.globalNamespace ? this.globalNamespace.toApiJson() : this.globalNamespace;
    }
    return toReturn;
  }
}
class NamespacePartnerNamespace {
  static fromProto(proto) {
    let m = new NamespacePartnerNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class NamespaceSystemNamespace {
  static fromProto(proto) {
    let m = new NamespaceSystemNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Function {
  static fromProto(proto) {
    let m = new Function();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.functionParameters) {
      m.functionParameters = proto.functionParameters.map(FunctionParameter.fromProto);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.headers) {
      m.headers = proto.headers.map(FunctionHeader.fromProto);
    }
    if (proto.authStrategy) {
      m.authStrategy = FunctionAuthStrategy.fromProto(proto.authStrategy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.methodType !== 'undefined') {
      toReturn['methodType'] = this.methodType;
    }
    if (typeof this.functionParameters !== 'undefined' && this.functionParameters !== null) {
      toReturn['functionParameters'] = 'toApiJson' in this.functionParameters ? this.functionParameters.toApiJson() : this.functionParameters;
    }
    if (typeof this.generatesAnswer !== 'undefined') {
      toReturn['generatesAnswer'] = this.generatesAnswer;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.headers !== 'undefined' && this.headers !== null) {
      toReturn['headers'] = 'toApiJson' in this.headers ? this.headers.toApiJson() : this.headers;
    }
    if (typeof this.managed !== 'undefined') {
      toReturn['managed'] = this.managed;
    }
    if (typeof this.authStrategy !== 'undefined' && this.authStrategy !== null) {
      toReturn['authStrategy'] = 'toApiJson' in this.authStrategy ? this.authStrategy.toApiJson() : this.authStrategy;
    }
    return toReturn;
  }
}
class FunctionAuthStrategy {
  static fromProto(proto) {
    let m = new FunctionAuthStrategy();
    m = Object.assign(m, proto);
    if (proto.unspecified) {
      m.unspecified = FunctionAuthStrategyUnspecifiedFunctionAuthStrategy.fromProto(proto.unspecified);
    }
    if (proto.platformManaged) {
      m.platformManaged = FunctionAuthStrategyPlatformManagedFunctionAuthStrategy.fromProto(proto.platformManaged);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.unspecified !== 'undefined' && this.unspecified !== null) {
      toReturn['unspecified'] = 'toApiJson' in this.unspecified ? this.unspecified.toApiJson() : this.unspecified;
    }
    if (typeof this.platformManaged !== 'undefined' && this.platformManaged !== null) {
      toReturn['platformManaged'] = 'toApiJson' in this.platformManaged ? this.platformManaged.toApiJson() : this.platformManaged;
    }
    return toReturn;
  }
}
class FunctionHeader {
  static fromProto(proto) {
    let m = new FunctionHeader();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class FunctionKey {
  static fromProto(proto) {
    let m = new FunctionKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class FunctionParameter {
  static fromProto(proto) {
    let m = new FunctionParameter();
    m = Object.assign(m, proto);
    if (proto.properties) {
      m.properties = proto.properties.map(FunctionParameter.fromProto);
    }
    if (proto.items) {
      m.items = FunctionParameter.fromProto(proto.items);
    }
    if (proto.location) {
      m.location = enumStringToValue$b(FunctionParameterParameterLocation, proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? this.properties.toApiJson() : this.properties;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    return toReturn;
  }
}
class FunctionAuthStrategyPlatformManagedFunctionAuthStrategy {
  static fromProto(proto) {
    let m = new FunctionAuthStrategyPlatformManagedFunctionAuthStrategy();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requiredScopes !== 'undefined') {
      toReturn['requiredScopes'] = this.requiredScopes;
    }
    return toReturn;
  }
}
class FunctionAuthStrategyUnspecifiedFunctionAuthStrategy {
  static fromProto(proto) {
    let m = new FunctionAuthStrategyUnspecifiedFunctionAuthStrategy();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Prompt {
  static fromProto(proto) {
    let m = new Prompt();
    m = Object.assign(m, proto);
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deployed) {
      m.deployed = new Date(proto.deployed);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.deployedVersion !== 'undefined') {
      toReturn['deployedVersion'] = this.deployedVersion;
    }
    if (typeof this.deployedBy !== 'undefined') {
      toReturn['deployedBy'] = this.deployedBy;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.deployed !== 'undefined' && this.deployed !== null) {
      toReturn['deployed'] = 'toApiJson' in this.deployed ? this.deployed.toApiJson() : this.deployed;
    }
    return toReturn;
  }
}
class PromptModule {
  static fromProto(proto) {
    let m = new PromptModule();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deployed) {
      m.deployed = new Date(proto.deployed);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.deployedVersion !== 'undefined') {
      toReturn['deployedVersion'] = this.deployedVersion;
    }
    if (typeof this.deployedBy !== 'undefined') {
      toReturn['deployedBy'] = this.deployedBy;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deployed !== 'undefined' && this.deployed !== null) {
      toReturn['deployed'] = 'toApiJson' in this.deployed ? this.deployed.toApiJson() : this.deployed;
    }
    if (typeof this.managed !== 'undefined') {
      toReturn['managed'] = this.managed;
    }
    return toReturn;
  }
}
class PromptModuleKey {
  static fromProto(proto) {
    let m = new PromptModuleKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class PromptModuleVersion {
  static fromProto(proto) {
    let m = new PromptModuleVersion();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class PromptVersion {
  static fromProto(proto) {
    let m = new PromptVersion();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Goal {
  static fromProto(proto) {
    let m = new Goal();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.type) {
      m.type = enumStringToValue$9(GoalType, proto.type);
    }
    if (proto.promptModules) {
      m.promptModules = proto.promptModules.map(PromptModule.fromProto);
    }
    if (proto.functions) {
      m.functions = proto.functions.map(Function.fromProto);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.supportedChannels) {
      m.supportedChannels = proto.supportedChannels.map(v => enumStringToValue$9(GoalChannel, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.promptModules !== 'undefined' && this.promptModules !== null) {
      toReturn['promptModules'] = 'toApiJson' in this.promptModules ? this.promptModules.toApiJson() : this.promptModules;
    }
    if (typeof this.functions !== 'undefined' && this.functions !== null) {
      toReturn['functions'] = 'toApiJson' in this.functions ? this.functions.toApiJson() : this.functions;
    }
    if (typeof this.updatedBy !== 'undefined') {
      toReturn['updatedBy'] = this.updatedBy;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.supportedChannels !== 'undefined') {
      toReturn['supportedChannels'] = this.supportedChannels;
    }
    if (typeof this.managed !== 'undefined') {
      toReturn['managed'] = this.managed;
    }
    return toReturn;
  }
}
class GoalKey {
  static fromProto(proto) {
    let m = new GoalKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class KeyValuePair {
  static fromProto(proto) {
    let m = new KeyValuePair();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Assistant {
  static fromProto(proto) {
    let m = new Assistant();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.type) {
      m.type = enumStringToValue$7(AssistantType, proto.type);
    }
    if (proto.config) {
      m.config = Config.fromProto(proto.config);
    }
    if (proto.configurableGoals) {
      m.configurableGoals = proto.configurableGoals.map(ConfigurableGoal.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.avatarUrl !== 'undefined') {
      toReturn['avatarUrl'] = this.avatarUrl;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.configurableGoals !== 'undefined' && this.configurableGoals !== null) {
      toReturn['configurableGoals'] = 'toApiJson' in this.configurableGoals ? this.configurableGoals.toApiJson() : this.configurableGoals;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class AssistantKey {
  static fromProto(proto) {
    let m = new AssistantKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class Config {
  static fromProto(proto) {
    let m = new Config();
    m = Object.assign(m, proto);
    if (proto.inboxConfig) {
      m.inboxConfig = ConfigInboxConfig.fromProto(proto.inboxConfig);
    }
    if (proto.voiceConfig) {
      m.voiceConfig = ConfigVoiceConfig.fromProto(proto.voiceConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inboxConfig !== 'undefined' && this.inboxConfig !== null) {
      toReturn['inboxConfig'] = 'toApiJson' in this.inboxConfig ? this.inboxConfig.toApiJson() : this.inboxConfig;
    }
    if (typeof this.voiceConfig !== 'undefined' && this.voiceConfig !== null) {
      toReturn['voiceConfig'] = 'toApiJson' in this.voiceConfig ? this.voiceConfig.toApiJson() : this.voiceConfig;
    }
    return toReturn;
  }
}
class ConfigurableGoal {
  static fromProto(proto) {
    let m = new ConfigurableGoal();
    m = Object.assign(m, proto);
    if (proto.goal) {
      m.goal = Goal.fromProto(proto.goal);
    }
    if (proto.configuration) {
      m.configuration = proto.configuration.map(KeyValuePair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goal !== 'undefined' && this.goal !== null) {
      toReturn['goal'] = 'toApiJson' in this.goal ? this.goal.toApiJson() : this.goal;
    }
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class DeepgramConfig {
  static fromProto(proto) {
    let m = new DeepgramConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.voice !== 'undefined') {
      toReturn['voice'] = this.voice;
    }
    return toReturn;
  }
}
class ConfigInboxConfig {
  static fromProto(proto) {
    let m = new ConfigInboxConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadCaptureEnabled !== 'undefined') {
      toReturn['leadCaptureEnabled'] = this.leadCaptureEnabled;
    }
    if (typeof this.additionalInstructions !== 'undefined') {
      toReturn['additionalInstructions'] = this.additionalInstructions;
    }
    return toReturn;
  }
}
class ModelConfig {
  static fromProto(proto) {
    let m = new ModelConfig();
    m = Object.assign(m, proto);
    if (proto.openaiRealtimeConfig) {
      m.openaiRealtimeConfig = OpenAIRealtimeConfig.fromProto(proto.openaiRealtimeConfig);
    }
    if (proto.deepgramConfig) {
      m.deepgramConfig = DeepgramConfig.fromProto(proto.deepgramConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.openaiRealtimeConfig !== 'undefined' && this.openaiRealtimeConfig !== null) {
      toReturn['openaiRealtimeConfig'] = 'toApiJson' in this.openaiRealtimeConfig ? this.openaiRealtimeConfig.toApiJson() : this.openaiRealtimeConfig;
    }
    if (typeof this.deepgramConfig !== 'undefined' && this.deepgramConfig !== null) {
      toReturn['deepgramConfig'] = 'toApiJson' in this.deepgramConfig ? this.deepgramConfig.toApiJson() : this.deepgramConfig;
    }
    return toReturn;
  }
}
class OpenAIRealtimeConfig {
  static fromProto(proto) {
    let m = new OpenAIRealtimeConfig();
    m = Object.assign(m, proto);
    if (proto.turnDetection) {
      m.turnDetection = OpenAIRealtimeConfigTurnDetection.fromProto(proto.turnDetection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.voice !== 'undefined') {
      toReturn['voice'] = this.voice;
    }
    if (typeof this.turnDetection !== 'undefined' && this.turnDetection !== null) {
      toReturn['turnDetection'] = 'toApiJson' in this.turnDetection ? this.turnDetection.toApiJson() : this.turnDetection;
    }
    return toReturn;
  }
}
class OpenAIRealtimeConfigTurnDetection {
  static fromProto(proto) {
    let m = new OpenAIRealtimeConfigTurnDetection();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.threshold !== 'undefined') {
      toReturn['threshold'] = this.threshold;
    }
    if (typeof this.prefixPadding !== 'undefined') {
      toReturn['prefixPadding'] = this.prefixPadding;
    }
    if (typeof this.silenceDuration !== 'undefined') {
      toReturn['silenceDuration'] = this.silenceDuration;
    }
    return toReturn;
  }
}
class ConfigVoiceConfig {
  static fromProto(proto) {
    let m = new ConfigVoiceConfig();
    m = Object.assign(m, proto);
    if (proto.vendorModel) {
      m.vendorModel = enumStringToValue$7(VendorModel, proto.vendorModel);
    }
    if (proto.modelConfig) {
      m.modelConfig = ModelConfig.fromProto(proto.modelConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorModel !== 'undefined') {
      toReturn['vendorModel'] = this.vendorModel;
    }
    if (typeof this.modelConfig !== 'undefined' && this.modelConfig !== null) {
      toReturn['modelConfig'] = 'toApiJson' in this.modelConfig ? this.modelConfig.toApiJson() : this.modelConfig;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Connection {
  static fromProto(proto) {
    let m = new Connection();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.assistantKeys) {
      m.assistantKeys = proto.assistantKeys.map(AssistantKey.fromProto);
    }
    if (proto.supportedAssistantTypes) {
      m.supportedAssistantTypes = proto.supportedAssistantTypes.map(v => enumStringToValue$6(AssistantType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.configurationUrl !== 'undefined') {
      toReturn['configurationUrl'] = this.configurationUrl;
    }
    if (typeof this.assistantKeys !== 'undefined' && this.assistantKeys !== null) {
      toReturn['assistantKeys'] = 'toApiJson' in this.assistantKeys ? this.assistantKeys.toApiJson() : this.assistantKeys;
    }
    if (typeof this.connectionType !== 'undefined') {
      toReturn['connectionType'] = this.connectionType;
    }
    if (typeof this.connectionTypeName !== 'undefined') {
      toReturn['connectionTypeName'] = this.connectionTypeName;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    if (typeof this.isConnectionLocked !== 'undefined') {
      toReturn['isConnectionLocked'] = this.isConnectionLocked;
    }
    if (typeof this.supportedAssistantTypes !== 'undefined') {
      toReturn['supportedAssistantTypes'] = this.supportedAssistantTypes;
    }
    return toReturn;
  }
}
class ConnectionKey {
  static fromProto(proto) {
    let m = new ConnectionKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.connectionType !== 'undefined') {
      toReturn['connectionType'] = this.connectionType;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ChatAnswerFunctionExecutionJob {
  static fromProto(proto) {
    let m = new ChatAnswerFunctionExecutionJob();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$5(ChatAnswerFunctionExecutionJobStatus, proto.status);
    }
    if (proto.result) {
      m.result = ChatAnswerFunctionExecutionJobResult.fromProto(proto.result);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.result !== 'undefined' && this.result !== null) {
      toReturn['result'] = 'toApiJson' in this.result ? this.result.toApiJson() : this.result;
    }
    if (typeof this.nextJobId !== 'undefined') {
      toReturn['nextJobId'] = this.nextJobId;
    }
    return toReturn;
  }
}
class ChatAnswerFunctionExecutionJobResult {
  static fromProto(proto) {
    let m = new ChatAnswerFunctionExecutionJobResult();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = proto.metadata.map(KeyValuePair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ChatMessage {
  static fromProto(proto) {
    let m = new ChatMessage();
    m = Object.assign(m, proto);
    if (proto.role) {
      m.role = enumStringToValue$5(ChatMessageRole, proto.role);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.role !== 'undefined') {
      toReturn['role'] = this.role;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class ChatUserInfo {
  static fromProto(proto) {
    let m = new ChatUserInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.address1 !== 'undefined') {
      toReturn['address1'] = this.address1;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zipCode !== 'undefined') {
      toReturn['zipCode'] = this.zipCode;
    }
    if (typeof this.timezone !== 'undefined') {
      toReturn['timezone'] = this.timezone;
    }
    return toReturn;
  }
}
class ContextInfo {
  static fromProto(proto) {
    let m = new ContextInfo();
    m = Object.assign(m, proto);
    if (proto.variables) {
      m.variables = proto.variables.map(KeyValuePair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.variables !== 'undefined' && this.variables !== null) {
      toReturn['variables'] = 'toApiJson' in this.variables ? this.variables.toApiJson() : this.variables;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DeleteTestCasesRequest {
  static fromProto(proto) {
    let m = new DeleteTestCasesRequest();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = ConnectionKey.fromProto(proto.connection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    if (typeof this.testCaseIds !== 'undefined') {
      toReturn['testCaseIds'] = this.testCaseIds;
    }
    return toReturn;
  }
}
class ListTestCasesByConnectionRequest {
  static fromProto(proto) {
    let m = new ListTestCasesByConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = ConnectionKey.fromProto(proto.connection);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListTestCasesByConnectionResponse {
  static fromProto(proto) {
    let m = new ListTestCasesByConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.testCases) {
      m.testCases = proto.testCases.map(TestCase.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.testCases !== 'undefined' && this.testCases !== null) {
      toReturn['testCases'] = 'toApiJson' in this.testCases ? this.testCases.toApiJson() : this.testCases;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class RunTestsRequest {
  static fromProto(proto) {
    let m = new RunTestsRequest();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = ConnectionKey.fromProto(proto.connection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    if (typeof this.testCaseIds !== 'undefined') {
      toReturn['testCaseIds'] = this.testCaseIds;
    }
    return toReturn;
  }
}
class RunTestsResponse {
  static fromProto(proto) {
    let m = new RunTestsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.buildUrl !== 'undefined') {
      toReturn['buildUrl'] = this.buildUrl;
    }
    return toReturn;
  }
}
class TestCase {
  static fromProto(proto) {
    let m = new TestCase();
    m = Object.assign(m, proto);
    if (proto.chatHistory) {
      m.chatHistory = proto.chatHistory.map(ChatMessage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.chatHistory !== 'undefined' && this.chatHistory !== null) {
      toReturn['chatHistory'] = 'toApiJson' in this.chatHistory ? this.chatHistory.toApiJson() : this.chatHistory;
    }
    if (typeof this.expectation !== 'undefined') {
      toReturn['expectation'] = this.expectation;
    }
    return toReturn;
  }
}
class UpsertTestCasesRequest {
  static fromProto(proto) {
    let m = new UpsertTestCasesRequest();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = ConnectionKey.fromProto(proto.connection);
    }
    if (proto.testCases) {
      m.testCases = proto.testCases.map(TestCase.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    if (typeof this.testCases !== 'undefined' && this.testCases !== null) {
      toReturn['testCases'] = 'toApiJson' in this.testCases ? this.testCases.toApiJson() : this.testCases;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BuildDefaultAssistantRequest {
  static fromProto(proto) {
    let m = new BuildDefaultAssistantRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.type) {
      m.type = enumStringToValue(AssistantType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class BuildDefaultAssistantResponse {
  static fromProto(proto) {
    let m = new BuildDefaultAssistantResponse();
    m = Object.assign(m, proto);
    if (proto.assistant) {
      m.assistant = Assistant.fromProto(proto.assistant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistant !== 'undefined' && this.assistant !== null) {
      toReturn['assistant'] = 'toApiJson' in this.assistant ? this.assistant.toApiJson() : this.assistant;
    }
    return toReturn;
  }
}
class SetAssistantConnectionsRequestConnectionState {
  static fromProto(proto) {
    let m = new SetAssistantConnectionsRequestConnectionState();
    m = Object.assign(m, proto);
    if (proto.connectionKey) {
      m.connectionKey = ConnectionKey.fromProto(proto.connectionKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionKey !== 'undefined' && this.connectionKey !== null) {
      toReturn['connectionKey'] = 'toApiJson' in this.connectionKey ? this.connectionKey.toApiJson() : this.connectionKey;
    }
    if (typeof this.isAssociated !== 'undefined') {
      toReturn['isAssociated'] = this.isAssociated;
    }
    return toReturn;
  }
}
class CreateAssistantRequest {
  static fromProto(proto) {
    let m = new CreateAssistantRequest();
    m = Object.assign(m, proto);
    if (proto.assistant) {
      m.assistant = Assistant.fromProto(proto.assistant);
    }
    if (proto.options) {
      m.options = CreateAssistantRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistant !== 'undefined' && this.assistant !== null) {
      toReturn['assistant'] = 'toApiJson' in this.assistant ? this.assistant.toApiJson() : this.assistant;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class CreateAssistantResponse {
  static fromProto(proto) {
    let m = new CreateAssistantResponse();
    m = Object.assign(m, proto);
    if (proto.assistant) {
      m.assistant = Assistant.fromProto(proto.assistant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistant !== 'undefined' && this.assistant !== null) {
      toReturn['assistant'] = 'toApiJson' in this.assistant ? this.assistant.toApiJson() : this.assistant;
    }
    return toReturn;
  }
}
class CreateGoalRequest {
  static fromProto(proto) {
    let m = new CreateGoalRequest();
    m = Object.assign(m, proto);
    if (proto.goal) {
      m.goal = Goal.fromProto(proto.goal);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goal !== 'undefined' && this.goal !== null) {
      toReturn['goal'] = 'toApiJson' in this.goal ? this.goal.toApiJson() : this.goal;
    }
    return toReturn;
  }
}
class CreateGoalResponse {
  static fromProto(proto) {
    let m = new CreateGoalResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreatePromptModuleRequest {
  static fromProto(proto) {
    let m = new CreatePromptModuleRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.managed !== 'undefined') {
      toReturn['managed'] = this.managed;
    }
    return toReturn;
  }
}
class CreatePromptModuleResponse {
  static fromProto(proto) {
    let m = new CreatePromptModuleResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreatePromptModuleVersionRequest {
  static fromProto(proto) {
    let m = new CreatePromptModuleVersionRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.options) {
      m.options = CreatePromptModuleVersionRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class CreatePromptRequest {
  static fromProto(proto) {
    let m = new CreatePromptRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class DeleteAssistantRequest {
  static fromProto(proto) {
    let m = new DeleteAssistantRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeleteConnectionRequest {
  static fromProto(proto) {
    let m = new DeleteConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.connectionType !== 'undefined') {
      toReturn['connectionType'] = this.connectionType;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeleteFunctionRequest {
  static fromProto(proto) {
    let m = new DeleteFunctionRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeleteGoalRequest {
  static fromProto(proto) {
    let m = new DeleteGoalRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeletePromptModuleRequest {
  static fromProto(proto) {
    let m = new DeletePromptModuleRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeletePromptRequest {
  static fromProto(proto) {
    let m = new DeletePromptRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DeployPromptModuleRequest {
  static fromProto(proto) {
    let m = new DeployPromptModuleRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class DeployPromptRequest {
  static fromProto(proto) {
    let m = new DeployPromptRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class ExecuteFunctionRequest {
  static fromProto(proto) {
    let m = new ExecuteFunctionRequest();
    m = Object.assign(m, proto);
    if (proto.assistantKey) {
      m.assistantKey = AssistantKey.fromProto(proto.assistantKey);
    }
    if (proto.functionKey) {
      m.functionKey = FunctionKey.fromProto(proto.functionKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistantKey !== 'undefined' && this.assistantKey !== null) {
      toReturn['assistantKey'] = 'toApiJson' in this.assistantKey ? this.assistantKey.toApiJson() : this.assistantKey;
    }
    if (typeof this.functionKey !== 'undefined' && this.functionKey !== null) {
      toReturn['functionKey'] = 'toApiJson' in this.functionKey ? this.functionKey.toApiJson() : this.functionKey;
    }
    if (typeof this.arguments !== 'undefined') {
      toReturn['arguments'] = this.arguments;
    }
    return toReturn;
  }
}
class ExecuteFunctionResponse {
  static fromProto(proto) {
    let m = new ExecuteFunctionResponse();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = proto.metadata.map(KeyValuePair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.output !== 'undefined') {
      toReturn['output'] = this.output;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListGoalsRequestFilters {
  static fromProto(proto) {
    let m = new ListGoalsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.type) {
      m.type = enumStringToValue(GoalType, proto.type);
    }
    if (proto.supportedChannels) {
      m.supportedChannels = proto.supportedChannels.map(v => enumStringToValue(GoalChannel, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.supportedChannels !== 'undefined') {
      toReturn['supportedChannels'] = this.supportedChannels;
    }
    return toReturn;
  }
}
class ListConnectionsRequestFilters {
  static fromProto(proto) {
    let m = new ListConnectionsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.assistantType) {
      m.assistantType = enumStringToValue(AssistantType, proto.assistantType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.assistantType !== 'undefined') {
      toReturn['assistantType'] = this.assistantType;
    }
    return toReturn;
  }
}
class ListFunctionRequestFilters {
  static fromProto(proto) {
    let m = new ListFunctionRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class ListAllAssistantsAssociatedToConnectionRequestFilters {
  static fromProto(proto) {
    let m = new ListAllAssistantsAssociatedToConnectionRequestFilters();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(AssistantType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class ListAssistantRequestFilters {
  static fromProto(proto) {
    let m = new ListAssistantRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.type) {
      m.type = enumStringToValue(AssistantType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class ListPromptModuleRequestFilters {
  static fromProto(proto) {
    let m = new ListPromptModuleRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class GenerateChatAnswerRequest {
  static fromProto(proto) {
    let m = new GenerateChatAnswerRequest();
    m = Object.assign(m, proto);
    if (proto.connectionKey) {
      m.connectionKey = ConnectionKey.fromProto(proto.connectionKey);
    }
    if (proto.chatHistory) {
      m.chatHistory = proto.chatHistory.map(ChatMessage.fromProto);
    }
    if (proto.chatUserInfo) {
      m.chatUserInfo = ChatUserInfo.fromProto(proto.chatUserInfo);
    }
    if (proto.chatChannel) {
      m.chatChannel = enumStringToValue(ChatChannel, proto.chatChannel);
    }
    if (proto.options) {
      m.options = GenerateChatAnswerRequestOptions.fromProto(proto.options);
    }
    if (proto.assistantKey) {
      m.assistantKey = AssistantKey.fromProto(proto.assistantKey);
    }
    if (proto.contextInfo) {
      m.contextInfo = ContextInfo.fromProto(proto.contextInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionKey !== 'undefined' && this.connectionKey !== null) {
      toReturn['connectionKey'] = 'toApiJson' in this.connectionKey ? this.connectionKey.toApiJson() : this.connectionKey;
    }
    if (typeof this.chatHistory !== 'undefined' && this.chatHistory !== null) {
      toReturn['chatHistory'] = 'toApiJson' in this.chatHistory ? this.chatHistory.toApiJson() : this.chatHistory;
    }
    if (typeof this.chatUserInfo !== 'undefined' && this.chatUserInfo !== null) {
      toReturn['chatUserInfo'] = 'toApiJson' in this.chatUserInfo ? this.chatUserInfo.toApiJson() : this.chatUserInfo;
    }
    if (typeof this.chatChannel !== 'undefined') {
      toReturn['chatChannel'] = this.chatChannel;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    if (typeof this.assistantKey !== 'undefined' && this.assistantKey !== null) {
      toReturn['assistantKey'] = 'toApiJson' in this.assistantKey ? this.assistantKey.toApiJson() : this.assistantKey;
    }
    if (typeof this.contextInfo !== 'undefined' && this.contextInfo !== null) {
      toReturn['contextInfo'] = 'toApiJson' in this.contextInfo ? this.contextInfo.toApiJson() : this.contextInfo;
    }
    return toReturn;
  }
}
class GenerateChatAnswerResponse {
  static fromProto(proto) {
    let m = new GenerateChatAnswerResponse();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = proto.metadata.map(KeyValuePair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.pendingJobId !== 'undefined') {
      toReturn['pendingJobId'] = this.pendingJobId;
    }
    return toReturn;
  }
}
class GetAssistantRequest {
  static fromProto(proto) {
    let m = new GetAssistantRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class GetAssistantResponse {
  static fromProto(proto) {
    let m = new GetAssistantResponse();
    m = Object.assign(m, proto);
    if (proto.assistant) {
      m.assistant = Assistant.fromProto(proto.assistant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistant !== 'undefined' && this.assistant !== null) {
      toReturn['assistant'] = 'toApiJson' in this.assistant ? this.assistant.toApiJson() : this.assistant;
    }
    return toReturn;
  }
}
class GetChatAnswerFunctionExecutionJobRequest {
  static fromProto(proto) {
    let m = new GetChatAnswerFunctionExecutionJobRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetChatAnswerFunctionExecutionJobResponse {
  static fromProto(proto) {
    let m = new GetChatAnswerFunctionExecutionJobResponse();
    m = Object.assign(m, proto);
    if (proto.job) {
      m.job = ChatAnswerFunctionExecutionJob.fromProto(proto.job);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.job !== 'undefined' && this.job !== null) {
      toReturn['job'] = 'toApiJson' in this.job ? this.job.toApiJson() : this.job;
    }
    return toReturn;
  }
}
class GetConnectionRequest {
  static fromProto(proto) {
    let m = new GetConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.connectionType !== 'undefined') {
      toReturn['connectionType'] = this.connectionType;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.includeAssistantKeys !== 'undefined') {
      toReturn['includeAssistantKeys'] = this.includeAssistantKeys;
    }
    return toReturn;
  }
}
class GetConnectionResponse {
  static fromProto(proto) {
    let m = new GetConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = Connection.fromProto(proto.connection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    return toReturn;
  }
}
class GetDeployedPromptModuleVersionRequest {
  static fromProto(proto) {
    let m = new GetDeployedPromptModuleVersionRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class GetDeployedPromptModuleVersionResponse {
  static fromProto(proto) {
    let m = new GetDeployedPromptModuleVersionResponse();
    m = Object.assign(m, proto);
    if (proto.promptModule) {
      m.promptModule = PromptModule.fromProto(proto.promptModule);
    }
    if (proto.deployedPromptModuleVersion) {
      m.deployedPromptModuleVersion = PromptModuleVersion.fromProto(proto.deployedPromptModuleVersion);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.promptModule !== 'undefined' && this.promptModule !== null) {
      toReturn['promptModule'] = 'toApiJson' in this.promptModule ? this.promptModule.toApiJson() : this.promptModule;
    }
    if (typeof this.deployedPromptModuleVersion !== 'undefined' && this.deployedPromptModuleVersion !== null) {
      toReturn['deployedPromptModuleVersion'] = 'toApiJson' in this.deployedPromptModuleVersion ? this.deployedPromptModuleVersion.toApiJson() : this.deployedPromptModuleVersion;
    }
    return toReturn;
  }
}
class GetDeployedPromptVersionRequest {
  static fromProto(proto) {
    let m = new GetDeployedPromptVersionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetDeployedPromptVersionResponse {
  static fromProto(proto) {
    let m = new GetDeployedPromptVersionResponse();
    m = Object.assign(m, proto);
    if (proto.prompt) {
      m.prompt = Prompt.fromProto(proto.prompt);
    }
    if (proto.deployedPromptVersion) {
      m.deployedPromptVersion = PromptVersion.fromProto(proto.deployedPromptVersion);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prompt !== 'undefined' && this.prompt !== null) {
      toReturn['prompt'] = 'toApiJson' in this.prompt ? this.prompt.toApiJson() : this.prompt;
    }
    if (typeof this.deployedPromptVersion !== 'undefined' && this.deployedPromptVersion !== null) {
      toReturn['deployedPromptVersion'] = 'toApiJson' in this.deployedPromptVersion ? this.deployedPromptVersion.toApiJson() : this.deployedPromptVersion;
    }
    return toReturn;
  }
}
class GetFunctionRequest {
  static fromProto(proto) {
    let m = new GetFunctionRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class GetFunctionResponse {
  static fromProto(proto) {
    let m = new GetFunctionResponse();
    m = Object.assign(m, proto);
    if (proto.function) {
      m.function = Function.fromProto(proto.function);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.function !== 'undefined' && this.function !== null) {
      toReturn['function'] = 'toApiJson' in this.function ? this.function.toApiJson() : this.function;
    }
    return toReturn;
  }
}
class GetGoalRequest {
  static fromProto(proto) {
    let m = new GetGoalRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class GetGoalResponse {
  static fromProto(proto) {
    let m = new GetGoalResponse();
    m = Object.assign(m, proto);
    if (proto.goal) {
      m.goal = Goal.fromProto(proto.goal);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goal !== 'undefined' && this.goal !== null) {
      toReturn['goal'] = 'toApiJson' in this.goal ? this.goal.toApiJson() : this.goal;
    }
    return toReturn;
  }
}
class GetHydratedDeployedPromptModuleVersionRequest {
  static fromProto(proto) {
    let m = new GetHydratedDeployedPromptModuleVersionRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.variables) {
      m.variables = proto.variables.map(KeyValuePair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.variables !== 'undefined' && this.variables !== null) {
      toReturn['variables'] = 'toApiJson' in this.variables ? this.variables.toApiJson() : this.variables;
    }
    return toReturn;
  }
}
class GetHydratedDeployedPromptModuleVersionResponse {
  static fromProto(proto) {
    let m = new GetHydratedDeployedPromptModuleVersionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class GetMultiDeployedPromptVersionRequest {
  static fromProto(proto) {
    let m = new GetMultiDeployedPromptVersionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ids !== 'undefined') {
      toReturn['ids'] = this.ids;
    }
    return toReturn;
  }
}
class GetMultiDeployedPromptVersionResponse {
  static fromProto(proto) {
    let m = new GetMultiDeployedPromptVersionResponse();
    m = Object.assign(m, proto);
    if (proto.prompts) {
      m.prompts = proto.prompts.map(Prompt.fromProto);
    }
    if (proto.deployedPromptVersions) {
      m.deployedPromptVersions = proto.deployedPromptVersions.map(PromptVersion.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prompts !== 'undefined' && this.prompts !== null) {
      toReturn['prompts'] = 'toApiJson' in this.prompts ? this.prompts.toApiJson() : this.prompts;
    }
    if (typeof this.deployedPromptVersions !== 'undefined' && this.deployedPromptVersions !== null) {
      toReturn['deployedPromptVersions'] = 'toApiJson' in this.deployedPromptVersions ? this.deployedPromptVersions.toApiJson() : this.deployedPromptVersions;
    }
    return toReturn;
  }
}
class GetMultiFunctionRequest {
  static fromProto(proto) {
    let m = new GetMultiFunctionRequest();
    m = Object.assign(m, proto);
    if (proto.keys) {
      m.keys = proto.keys.map(FunctionKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keys !== 'undefined' && this.keys !== null) {
      toReturn['keys'] = 'toApiJson' in this.keys ? this.keys.toApiJson() : this.keys;
    }
    return toReturn;
  }
}
class GetMultiFunctionResponse {
  static fromProto(proto) {
    let m = new GetMultiFunctionResponse();
    m = Object.assign(m, proto);
    if (proto.functions) {
      m.functions = proto.functions.map(Function.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.functions !== 'undefined' && this.functions !== null) {
      toReturn['functions'] = 'toApiJson' in this.functions ? this.functions.toApiJson() : this.functions;
    }
    return toReturn;
  }
}
class GetMultiGoalRequest {
  static fromProto(proto) {
    let m = new GetMultiGoalRequest();
    m = Object.assign(m, proto);
    if (proto.keys) {
      m.keys = proto.keys.map(GoalKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keys !== 'undefined' && this.keys !== null) {
      toReturn['keys'] = 'toApiJson' in this.keys ? this.keys.toApiJson() : this.keys;
    }
    return toReturn;
  }
}
class GetMultiGoalResponse {
  static fromProto(proto) {
    let m = new GetMultiGoalResponse();
    m = Object.assign(m, proto);
    if (proto.goals) {
      m.goals = proto.goals.map(Goal.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goals !== 'undefined' && this.goals !== null) {
      toReturn['goals'] = 'toApiJson' in this.goals ? this.goals.toApiJson() : this.goals;
    }
    return toReturn;
  }
}
class GetMultiHydratedDeployedPromptModuleVersionRequest {
  static fromProto(proto) {
    let m = new GetMultiHydratedDeployedPromptModuleVersionRequest();
    m = Object.assign(m, proto);
    if (proto.keys) {
      m.keys = proto.keys.map(PromptModuleKey.fromProto);
    }
    if (proto.variables) {
      m.variables = proto.variables.map(KeyValuePair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keys !== 'undefined' && this.keys !== null) {
      toReturn['keys'] = 'toApiJson' in this.keys ? this.keys.toApiJson() : this.keys;
    }
    if (typeof this.variables !== 'undefined' && this.variables !== null) {
      toReturn['variables'] = 'toApiJson' in this.variables ? this.variables.toApiJson() : this.variables;
    }
    return toReturn;
  }
}
class GetMultiHydratedDeployedPromptModuleVersionResponse {
  static fromProto(proto) {
    let m = new GetMultiHydratedDeployedPromptModuleVersionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contents !== 'undefined') {
      toReturn['contents'] = this.contents;
    }
    return toReturn;
  }
}
class GetPromptModuleRequest {
  static fromProto(proto) {
    let m = new GetPromptModuleRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class GetPromptModuleResponse {
  static fromProto(proto) {
    let m = new GetPromptModuleResponse();
    m = Object.assign(m, proto);
    if (proto.promptModule) {
      m.promptModule = PromptModule.fromProto(proto.promptModule);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.promptModule !== 'undefined' && this.promptModule !== null) {
      toReturn['promptModule'] = 'toApiJson' in this.promptModule ? this.promptModule.toApiJson() : this.promptModule;
    }
    return toReturn;
  }
}
class GetPromptModuleVersionRequest {
  static fromProto(proto) {
    let m = new GetPromptModuleVersionRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class GetPromptModuleVersionResponse {
  static fromProto(proto) {
    let m = new GetPromptModuleVersionResponse();
    m = Object.assign(m, proto);
    if (proto.promptModuleVersion) {
      m.promptModuleVersion = PromptModuleVersion.fromProto(proto.promptModuleVersion);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.promptModuleVersion !== 'undefined' && this.promptModuleVersion !== null) {
      toReturn['promptModuleVersion'] = 'toApiJson' in this.promptModuleVersion ? this.promptModuleVersion.toApiJson() : this.promptModuleVersion;
    }
    return toReturn;
  }
}
class GetPromptRequest {
  static fromProto(proto) {
    let m = new GetPromptRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetPromptResponse {
  static fromProto(proto) {
    let m = new GetPromptResponse();
    m = Object.assign(m, proto);
    if (proto.prompt) {
      m.prompt = Prompt.fromProto(proto.prompt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prompt !== 'undefined' && this.prompt !== null) {
      toReturn['prompt'] = 'toApiJson' in this.prompt ? this.prompt.toApiJson() : this.prompt;
    }
    return toReturn;
  }
}
class GetPromptVersionRequest {
  static fromProto(proto) {
    let m = new GetPromptVersionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class GetPromptVersionResponse {
  static fromProto(proto) {
    let m = new GetPromptVersionResponse();
    m = Object.assign(m, proto);
    if (proto.promptVersion) {
      m.promptVersion = PromptVersion.fromProto(proto.promptVersion);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.promptVersion !== 'undefined' && this.promptVersion !== null) {
      toReturn['promptVersion'] = 'toApiJson' in this.promptVersion ? this.promptVersion.toApiJson() : this.promptVersion;
    }
    return toReturn;
  }
}
class GoalsDisabledForAccountGroupRequest {
  static fromProto(proto) {
    let m = new GoalsDisabledForAccountGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GoalsDisabledForAccountGroupResponse {
  static fromProto(proto) {
    let m = new GoalsDisabledForAccountGroupResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goalsDisabled !== 'undefined') {
      toReturn['goalsDisabled'] = this.goalsDisabled;
    }
    return toReturn;
  }
}
class ListAllAssistantsAssociatedToConnectionRequest {
  static fromProto(proto) {
    let m = new ListAllAssistantsAssociatedToConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.connectionKey) {
      m.connectionKey = ConnectionKey.fromProto(proto.connectionKey);
    }
    if (proto.filters) {
      m.filters = ListAllAssistantsAssociatedToConnectionRequestFilters.fromProto(proto.filters);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionKey !== 'undefined' && this.connectionKey !== null) {
      toReturn['connectionKey'] = 'toApiJson' in this.connectionKey ? this.connectionKey.toApiJson() : this.connectionKey;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class ListAllAssistantsAssociatedToConnectionResponse {
  static fromProto(proto) {
    let m = new ListAllAssistantsAssociatedToConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.assistants) {
      m.assistants = proto.assistants.map(Assistant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistants !== 'undefined' && this.assistants !== null) {
      toReturn['assistants'] = 'toApiJson' in this.assistants ? this.assistants.toApiJson() : this.assistants;
    }
    return toReturn;
  }
}
class ListAssistantRequest {
  static fromProto(proto) {
    let m = new ListAssistantRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListAssistantRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAssistantResponse {
  static fromProto(proto) {
    let m = new ListAssistantResponse();
    m = Object.assign(m, proto);
    if (proto.assistants) {
      m.assistants = proto.assistants.map(Assistant.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistants !== 'undefined' && this.assistants !== null) {
      toReturn['assistants'] = 'toApiJson' in this.assistants ? this.assistants.toApiJson() : this.assistants;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListConnectionsRequest {
  static fromProto(proto) {
    let m = new ListConnectionsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListConnectionsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.includeAssistantKeys !== 'undefined') {
      toReturn['includeAssistantKeys'] = this.includeAssistantKeys;
    }
    return toReturn;
  }
}
class ListConnectionsResponse {
  static fromProto(proto) {
    let m = new ListConnectionsResponse();
    m = Object.assign(m, proto);
    if (proto.connections) {
      m.connections = proto.connections.map(Connection.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connections !== 'undefined' && this.connections !== null) {
      toReturn['connections'] = 'toApiJson' in this.connections ? this.connections.toApiJson() : this.connections;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListFunctionRequest {
  static fromProto(proto) {
    let m = new ListFunctionRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListFunctionRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListFunctionResponse {
  static fromProto(proto) {
    let m = new ListFunctionResponse();
    m = Object.assign(m, proto);
    if (proto.functions) {
      m.functions = proto.functions.map(Function.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.functions !== 'undefined' && this.functions !== null) {
      toReturn['functions'] = 'toApiJson' in this.functions ? this.functions.toApiJson() : this.functions;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListGoalsRequest {
  static fromProto(proto) {
    let m = new ListGoalsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListGoalsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListGoalsResponse {
  static fromProto(proto) {
    let m = new ListGoalsResponse();
    m = Object.assign(m, proto);
    if (proto.goals) {
      m.goals = proto.goals.map(Goal.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goals !== 'undefined' && this.goals !== null) {
      toReturn['goals'] = 'toApiJson' in this.goals ? this.goals.toApiJson() : this.goals;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListPromptModuleRequest {
  static fromProto(proto) {
    let m = new ListPromptModuleRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListPromptModuleRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListPromptModuleResponse {
  static fromProto(proto) {
    let m = new ListPromptModuleResponse();
    m = Object.assign(m, proto);
    if (proto.promptModules) {
      m.promptModules = proto.promptModules.map(PromptModule.fromProto);
    }
    if (proto.deployedPromptModuleVersions) {
      m.deployedPromptModuleVersions = proto.deployedPromptModuleVersions.map(PromptModuleVersion.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.promptModules !== 'undefined' && this.promptModules !== null) {
      toReturn['promptModules'] = 'toApiJson' in this.promptModules ? this.promptModules.toApiJson() : this.promptModules;
    }
    if (typeof this.deployedPromptModuleVersions !== 'undefined' && this.deployedPromptModuleVersions !== null) {
      toReturn['deployedPromptModuleVersions'] = 'toApiJson' in this.deployedPromptModuleVersions ? this.deployedPromptModuleVersions.toApiJson() : this.deployedPromptModuleVersions;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListPromptModuleVersionsRequest {
  static fromProto(proto) {
    let m = new ListPromptModuleVersionsRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListPromptModuleVersionsResponse {
  static fromProto(proto) {
    let m = new ListPromptModuleVersionsResponse();
    m = Object.assign(m, proto);
    if (proto.promptModuleVersions) {
      m.promptModuleVersions = proto.promptModuleVersions.map(PromptModuleVersion.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.promptModuleVersions !== 'undefined' && this.promptModuleVersions !== null) {
      toReturn['promptModuleVersions'] = 'toApiJson' in this.promptModuleVersions ? this.promptModuleVersions.toApiJson() : this.promptModuleVersions;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListPromptRequest {
  static fromProto(proto) {
    let m = new ListPromptRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListPromptResponse {
  static fromProto(proto) {
    let m = new ListPromptResponse();
    m = Object.assign(m, proto);
    if (proto.prompts) {
      m.prompts = proto.prompts.map(Prompt.fromProto);
    }
    if (proto.deployedPromptVersions) {
      m.deployedPromptVersions = proto.deployedPromptVersions.map(PromptVersion.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prompts !== 'undefined' && this.prompts !== null) {
      toReturn['prompts'] = 'toApiJson' in this.prompts ? this.prompts.toApiJson() : this.prompts;
    }
    if (typeof this.deployedPromptVersions !== 'undefined' && this.deployedPromptVersions !== null) {
      toReturn['deployedPromptVersions'] = 'toApiJson' in this.deployedPromptVersions ? this.deployedPromptVersions.toApiJson() : this.deployedPromptVersions;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListPromptVersionsRequest {
  static fromProto(proto) {
    let m = new ListPromptVersionsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListPromptVersionsResponse {
  static fromProto(proto) {
    let m = new ListPromptVersionsResponse();
    m = Object.assign(m, proto);
    if (proto.promptVersions) {
      m.promptVersions = proto.promptVersions.map(PromptVersion.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.promptVersions !== 'undefined' && this.promptVersions !== null) {
      toReturn['promptVersions'] = 'toApiJson' in this.promptVersions ? this.promptVersions.toApiJson() : this.promptVersions;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class GenerateChatAnswerRequestOptions {
  static fromProto(proto) {
    let m = new GenerateChatAnswerRequestOptions();
    m = Object.assign(m, proto);
    if (proto.maxTokens) {
      m.maxTokens = parseInt(proto.maxTokens, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeAllCitations !== 'undefined') {
      toReturn['includeAllCitations'] = this.includeAllCitations;
    }
    if (typeof this.enableAsyncFunctions !== 'undefined') {
      toReturn['enableAsyncFunctions'] = this.enableAsyncFunctions;
    }
    if (typeof this.maxTokens !== 'undefined') {
      toReturn['maxTokens'] = this.maxTokens;
    }
    return toReturn;
  }
}
class CreateAssistantRequestOptions {
  static fromProto(proto) {
    let m = new CreateAssistantRequestOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applyDefaults !== 'undefined') {
      toReturn['applyDefaults'] = this.applyDefaults;
    }
    return toReturn;
  }
}
class CreatePromptModuleVersionRequestOptions {
  static fromProto(proto) {
    let m = new CreatePromptModuleVersionRequestOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.shouldDeploy !== 'undefined') {
      toReturn['shouldDeploy'] = this.shouldDeploy;
    }
    return toReturn;
  }
}
class UpsertAssistantRequestOptions {
  static fromProto(proto) {
    let m = new UpsertAssistantRequestOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.applyDefaults !== 'undefined') {
      toReturn['applyDefaults'] = this.applyDefaults;
    }
    return toReturn;
  }
}
class SetAssistantConnectionsRequest {
  static fromProto(proto) {
    let m = new SetAssistantConnectionsRequest();
    m = Object.assign(m, proto);
    if (proto.associationStates) {
      m.associationStates = proto.associationStates.map(SetAssistantConnectionsRequestConnectionState.fromProto);
    }
    if (proto.assistantKey) {
      m.assistantKey = AssistantKey.fromProto(proto.assistantKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.associationStates !== 'undefined' && this.associationStates !== null) {
      toReturn['associationStates'] = 'toApiJson' in this.associationStates ? this.associationStates.toApiJson() : this.associationStates;
    }
    if (typeof this.assistantKey !== 'undefined' && this.assistantKey !== null) {
      toReturn['assistantKey'] = 'toApiJson' in this.assistantKey ? this.assistantKey.toApiJson() : this.assistantKey;
    }
    return toReturn;
  }
}
class UpdateAssistantRequest {
  static fromProto(proto) {
    let m = new UpdateAssistantRequest();
    m = Object.assign(m, proto);
    if (proto.assistant) {
      m.assistant = Assistant.fromProto(proto.assistant);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistant !== 'undefined' && this.assistant !== null) {
      toReturn['assistant'] = 'toApiJson' in this.assistant ? this.assistant.toApiJson() : this.assistant;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateGoalRequest {
  static fromProto(proto) {
    let m = new UpdateGoalRequest();
    m = Object.assign(m, proto);
    if (proto.goal) {
      m.goal = Goal.fromProto(proto.goal);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goal !== 'undefined' && this.goal !== null) {
      toReturn['goal'] = 'toApiJson' in this.goal ? this.goal.toApiJson() : this.goal;
    }
    return toReturn;
  }
}
class UpdatePromptModuleRequest {
  static fromProto(proto) {
    let m = new UpdatePromptModuleRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class UpdatePromptRequest {
  static fromProto(proto) {
    let m = new UpdatePromptRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class UpsertAssistantRequest {
  static fromProto(proto) {
    let m = new UpsertAssistantRequest();
    m = Object.assign(m, proto);
    if (proto.assistant) {
      m.assistant = Assistant.fromProto(proto.assistant);
    }
    if (proto.options) {
      m.options = UpsertAssistantRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistant !== 'undefined' && this.assistant !== null) {
      toReturn['assistant'] = 'toApiJson' in this.assistant ? this.assistant.toApiJson() : this.assistant;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class UpsertAssistantResponse {
  static fromProto(proto) {
    let m = new UpsertAssistantResponse();
    m = Object.assign(m, proto);
    if (proto.assistant) {
      m.assistant = Assistant.fromProto(proto.assistant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.assistant !== 'undefined' && this.assistant !== null) {
      toReturn['assistant'] = 'toApiJson' in this.assistant ? this.assistant.toApiJson() : this.assistant;
    }
    return toReturn;
  }
}
class UpsertConnectionRequest {
  static fromProto(proto) {
    let m = new UpsertConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = Connection.fromProto(proto.connection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    return toReturn;
  }
}
class UpsertFunctionRequest {
  static fromProto(proto) {
    let m = new UpsertFunctionRequest();
    m = Object.assign(m, proto);
    if (proto.function) {
      m.function = Function.fromProto(proto.function);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.function !== 'undefined' && this.function !== null) {
      toReturn['function'] = 'toApiJson' in this.function ? this.function.toApiJson() : this.function;
    }
    return toReturn;
  }
}
class UpsertGoalRequest {
  static fromProto(proto) {
    let m = new UpsertGoalRequest();
    m = Object.assign(m, proto);
    if (proto.goal) {
      m.goal = Goal.fromProto(proto.goal);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goal !== 'undefined' && this.goal !== null) {
      toReturn['goal'] = 'toApiJson' in this.goal ? this.goal.toApiJson() : this.goal;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AssistantApiService = /*#__PURE__*/(() => {
  class AssistantApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsertAssistant(r) {
      const request = r.toApiJson ? r : new UpsertAssistantRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/UpsertAssistant", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpsertAssistantResponse.fromProto(resp)));
    }
    createAssistant(r) {
      const request = r.toApiJson ? r : new CreateAssistantRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/CreateAssistant", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAssistantResponse.fromProto(resp)));
    }
    updateAssistant(r) {
      const request = r.toApiJson ? r : new UpdateAssistantRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/UpdateAssistant", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAssistant(r) {
      const request = r.toApiJson ? r : new GetAssistantRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/GetAssistant", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAssistantResponse.fromProto(resp)));
    }
    buildDefaultAssistant(r) {
      const request = r.toApiJson ? r : new BuildDefaultAssistantRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/BuildDefaultAssistant", request.toApiJson(), this.apiOptions()).pipe(map(resp => BuildDefaultAssistantResponse.fromProto(resp)));
    }
    deleteAssistant(r) {
      const request = r.toApiJson ? r : new DeleteAssistantRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/DeleteAssistant", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listAssistant(r) {
      const request = r.toApiJson ? r : new ListAssistantRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/ListAssistant", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAssistantResponse.fromProto(resp)));
    }
    listAllAssistantsAssociatedToConnection(r) {
      const request = r.toApiJson ? r : new ListAllAssistantsAssociatedToConnectionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/ListAllAssistantsAssociatedToConnection", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAllAssistantsAssociatedToConnectionResponse.fromProto(resp)));
    }
    generateChatAnswer(r) {
      const request = r.toApiJson ? r : new GenerateChatAnswerRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/GenerateChatAnswer", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateChatAnswerResponse.fromProto(resp)));
    }
    getChatAnswerFunctionExecutionJob(r) {
      const request = r.toApiJson ? r : new GetChatAnswerFunctionExecutionJobRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/GetChatAnswerFunctionExecutionJob", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetChatAnswerFunctionExecutionJobResponse.fromProto(resp)));
    }
    setAssistantConnections(r) {
      const request = r.toApiJson ? r : new SetAssistantConnectionsRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/SetAssistantConnections", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    executeFunction(r) {
      const request = r.toApiJson ? r : new ExecuteFunctionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.AssistantService/ExecuteFunction", request.toApiJson(), this.apiOptions()).pipe(map(resp => ExecuteFunctionResponse.fromProto(resp)));
    }
  }
  AssistantApiService.ɵfac = function AssistantApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AssistantApiService)();
  };
  AssistantApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AssistantApiService,
    factory: AssistantApiService.ɵfac,
    providedIn: 'root'
  });
  return AssistantApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ConnectionApiService = /*#__PURE__*/(() => {
  class ConnectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsertConnection(r) {
      const request = r.toApiJson ? r : new UpsertConnectionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.ConnectionService/UpsertConnection", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getConnection(r) {
      const request = r.toApiJson ? r : new GetConnectionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.ConnectionService/GetConnection", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConnectionResponse.fromProto(resp)));
    }
    deleteConnection(r) {
      const request = r.toApiJson ? r : new DeleteConnectionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.ConnectionService/DeleteConnection", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listConnections(r) {
      const request = r.toApiJson ? r : new ListConnectionsRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.ConnectionService/ListConnections", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListConnectionsResponse.fromProto(resp)));
    }
  }
  ConnectionApiService.ɵfac = function ConnectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ConnectionApiService)();
  };
  ConnectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConnectionApiService,
    factory: ConnectionApiService.ɵfac,
    providedIn: 'root'
  });
  return ConnectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let FunctionApiService = /*#__PURE__*/(() => {
  class FunctionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsert(r) {
      const request = r.toApiJson ? r : new UpsertFunctionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.FunctionService/Upsert", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetFunctionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.FunctionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFunctionResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiFunctionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.FunctionService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiFunctionResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListFunctionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.FunctionService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFunctionResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteFunctionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.FunctionService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  FunctionApiService.ɵfac = function FunctionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FunctionApiService)();
  };
  FunctionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FunctionApiService,
    factory: FunctionApiService.ɵfac,
    providedIn: 'root'
  });
  return FunctionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let GoalApiService = /*#__PURE__*/(() => {
  class GoalApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsert(r) {
      const request = r.toApiJson ? r : new UpsertGoalRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.GoalService/Upsert", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateGoalRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.GoalService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateGoalResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateGoalRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.GoalService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetGoalRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.GoalService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGoalResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiGoalRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.GoalService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiGoalResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteGoalRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.GoalService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListGoalsRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.GoalService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGoalsResponse.fromProto(resp)));
    }
    goalsDisabledForAccountGroup(r) {
      const request = r.toApiJson ? r : new GoalsDisabledForAccountGroupRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.GoalService/GoalsDisabledForAccountGroup", request.toApiJson(), this.apiOptions()).pipe(map(resp => GoalsDisabledForAccountGroupResponse.fromProto(resp)));
    }
  }
  GoalApiService.ɵfac = function GoalApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GoalApiService)();
  };
  GoalApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GoalApiService,
    factory: GoalApiService.ɵfac,
    providedIn: 'root'
  });
  return GoalApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IntegrationTestApiService = /*#__PURE__*/(() => {
  class IntegrationTestApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listTestCasesByConnection(r) {
      const request = r.toApiJson ? r : new ListTestCasesByConnectionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.IntegrationTestService/ListTestCasesByConnection", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTestCasesByConnectionResponse.fromProto(resp)));
    }
    upsertTestCases(r) {
      const request = r.toApiJson ? r : new UpsertTestCasesRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.IntegrationTestService/UpsertTestCases", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteTestCases(r) {
      const request = r.toApiJson ? r : new DeleteTestCasesRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.IntegrationTestService/DeleteTestCases", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    runTests(r) {
      const request = r.toApiJson ? r : new RunTestsRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.IntegrationTestService/RunTests", request.toApiJson(), this.apiOptions()).pipe(map(resp => RunTestsResponse.fromProto(resp)));
    }
  }
  IntegrationTestApiService.ɵfac = function IntegrationTestApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntegrationTestApiService)();
  };
  IntegrationTestApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationTestApiService,
    factory: IntegrationTestApiService.ɵfac,
    providedIn: 'root'
  });
  return IntegrationTestApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PromptModuleApiService = /*#__PURE__*/(() => {
  class PromptModuleApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreatePromptModuleRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePromptModuleResponse.fromProto(resp)));
    }
    createVersion(r) {
      const request = r.toApiJson ? r : new CreatePromptModuleVersionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/CreateVersion", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetPromptModuleRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPromptModuleResponse.fromProto(resp)));
    }
    getVersion(r) {
      const request = r.toApiJson ? r : new GetPromptModuleVersionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/GetVersion", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPromptModuleVersionResponse.fromProto(resp)));
    }
    getDeployedVersion(r) {
      const request = r.toApiJson ? r : new GetDeployedPromptModuleVersionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/GetDeployedVersion", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDeployedPromptModuleVersionResponse.fromProto(resp)));
    }
    getHydratedDeployedVersion(r) {
      const request = r.toApiJson ? r : new GetHydratedDeployedPromptModuleVersionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/GetHydratedDeployedVersion", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetHydratedDeployedPromptModuleVersionResponse.fromProto(resp)));
    }
    getMultiHydratedDeployedVersion(r) {
      const request = r.toApiJson ? r : new GetMultiHydratedDeployedPromptModuleVersionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/GetMultiHydratedDeployedVersion", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiHydratedDeployedPromptModuleVersionResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdatePromptModuleRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deploy(r) {
      const request = r.toApiJson ? r : new DeployPromptModuleRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/Deploy", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListPromptModuleRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPromptModuleResponse.fromProto(resp)));
    }
    listVersions(r) {
      const request = r.toApiJson ? r : new ListPromptModuleVersionsRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/ListVersions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPromptModuleVersionsResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeletePromptModuleRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptModuleService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PromptModuleApiService.ɵfac = function PromptModuleApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PromptModuleApiService)();
  };
  PromptModuleApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PromptModuleApiService,
    factory: PromptModuleApiService.ɵfac,
    providedIn: 'root'
  });
  return PromptModuleApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PromptApiService = /*#__PURE__*/(() => {
  class PromptApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreatePromptRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/Create", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetPromptRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPromptResponse.fromProto(resp)));
    }
    getVersion(r) {
      const request = r.toApiJson ? r : new GetPromptVersionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/GetVersion", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPromptVersionResponse.fromProto(resp)));
    }
    getDeployedVersion(r) {
      const request = r.toApiJson ? r : new GetDeployedPromptVersionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/GetDeployedVersion", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDeployedPromptVersionResponse.fromProto(resp)));
    }
    getMultiDeployedVersion(r) {
      const request = r.toApiJson ? r : new GetMultiDeployedPromptVersionRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/GetMultiDeployedVersion", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiDeployedPromptVersionResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdatePromptRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deploy(r) {
      const request = r.toApiJson ? r : new DeployPromptRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/Deploy", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListPromptRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPromptResponse.fromProto(resp)));
    }
    listVersions(r) {
      const request = r.toApiJson ? r : new ListPromptVersionsRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/ListVersions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPromptVersionsResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeletePromptRequest(r);
      return this.http.post(this._host + "/ai_assistants.v1alpha1.PromptService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PromptApiService.ɵfac = function PromptApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PromptApiService)();
  };
  PromptApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PromptApiService,
    factory: PromptApiService.ɵfac,
    providedIn: 'root'
  });
  return PromptApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, Assistant, AssistantApiService, AssistantKey, AssistantType, BuildDefaultAssistantRequest, BuildDefaultAssistantResponse, ChatAnswerFunctionExecutionJob, ChatAnswerFunctionExecutionJobResult, ChatAnswerFunctionExecutionJobStatus, ChatChannel, ChatMessage, ChatMessageRole, ChatUserInfo, Config, ConfigInboxConfig, ConfigVoiceConfig, ConfigurableGoal, Connection, ConnectionApiService, ConnectionKey, ContextInfo, CreateAssistantRequest, CreateAssistantRequestOptions, CreateAssistantResponse, CreateGoalRequest, CreateGoalResponse, CreatePromptModuleRequest, CreatePromptModuleResponse, CreatePromptModuleVersionRequest, CreatePromptModuleVersionRequestOptions, CreatePromptRequest, DeepgramConfig, DeleteAssistantRequest, DeleteConnectionRequest, DeleteFunctionRequest, DeleteGoalRequest, DeletePromptModuleRequest, DeletePromptRequest, DeleteTestCasesRequest, DeployPromptModuleRequest, DeployPromptRequest, ExecuteFunctionRequest, ExecuteFunctionResponse, FieldMask, Function, FunctionApiService, FunctionAuthStrategy, FunctionAuthStrategyPlatformManagedFunctionAuthStrategy, FunctionAuthStrategyUnspecifiedFunctionAuthStrategy, FunctionHeader, FunctionKey, FunctionParameter, FunctionParameterParameterLocation, GenerateChatAnswerRequest, GenerateChatAnswerRequestOptions, GenerateChatAnswerResponse, GetAssistantRequest, GetAssistantResponse, GetChatAnswerFunctionExecutionJobRequest, GetChatAnswerFunctionExecutionJobResponse, GetConnectionRequest, GetConnectionResponse, GetDeployedPromptModuleVersionRequest, GetDeployedPromptModuleVersionResponse, GetDeployedPromptVersionRequest, GetDeployedPromptVersionResponse, GetFunctionRequest, GetFunctionResponse, GetGoalRequest, GetGoalResponse, GetHydratedDeployedPromptModuleVersionRequest, GetHydratedDeployedPromptModuleVersionResponse, GetMultiDeployedPromptVersionRequest, GetMultiDeployedPromptVersionResponse, GetMultiFunctionRequest, GetMultiFunctionResponse, GetMultiGoalRequest, GetMultiGoalResponse, GetMultiHydratedDeployedPromptModuleVersionRequest, GetMultiHydratedDeployedPromptModuleVersionResponse, GetPromptModuleRequest, GetPromptModuleResponse, GetPromptModuleVersionRequest, GetPromptModuleVersionResponse, GetPromptRequest, GetPromptResponse, GetPromptVersionRequest, GetPromptVersionResponse, Goal, GoalApiService, GoalChannel, GoalKey, GoalType, GoalsDisabledForAccountGroupRequest, GoalsDisabledForAccountGroupResponse, HostService, IntegrationTestApiService, KeyValuePair, ListAllAssistantsAssociatedToConnectionRequest, ListAllAssistantsAssociatedToConnectionRequestFilters, ListAllAssistantsAssociatedToConnectionResponse, ListAssistantRequest, ListAssistantRequestFilters, ListAssistantResponse, ListConnectionsRequest, ListConnectionsRequestFilters, ListConnectionsResponse, ListFunctionRequest, ListFunctionRequestFilters, ListFunctionResponse, ListGoalsRequest, ListGoalsRequestFilters, ListGoalsResponse, ListPromptModuleRequest, ListPromptModuleRequestFilters, ListPromptModuleResponse, ListPromptModuleVersionsRequest, ListPromptModuleVersionsResponse, ListPromptRequest, ListPromptResponse, ListPromptVersionsRequest, ListPromptVersionsResponse, ListTestCasesByConnectionRequest, ListTestCasesByConnectionResponse, ModelConfig, Namespace, NamespaceAccountGroupNamespace, NamespaceGlobalNamespace, NamespacePartnerNamespace, NamespaceSystemNamespace, OpenAIRealtimeConfig, OpenAIRealtimeConfigTurnDetection, PagedRequestOptions, PagedResponseMetadata, Prompt, PromptApiService, PromptModule, PromptModuleApiService, PromptModuleKey, PromptModuleVersion, PromptVersion, RunTestsRequest, RunTestsResponse, SetAssistantConnectionsRequest, SetAssistantConnectionsRequestConnectionState, TestCase, UpdateAssistantRequest, UpdateGoalRequest, UpdatePromptModuleRequest, UpdatePromptRequest, UpsertAssistantRequest, UpsertAssistantRequestOptions, UpsertAssistantResponse, UpsertConnectionRequest, UpsertFunctionRequest, UpsertGoalRequest, UpsertTestCasesRequest, VendorModel };
